import Http from './http'

class UsersService {
  constructor () {
    this.baseUrl = 'user-biblioteca'
  }

  getMe () {
    return Http.get(this.baseUrl + '/me')
  }

  saveMe (user) {
    return Http.get(this.baseUrl + '/me',user)
  }

  getOne(id) {
    return Http.get(`${this.baseUrl}/${id}`)
  }

  save(id, data) {
    return Http.put(`${this.baseUrl}/${id}`, data)
  }

  create(data) {
    return Http.post(this.baseUrl, data)
  }

  edit(id, data) {
    return Http.put(`${this.baseUrl}/${id}`, data);
  }

  getAll(filter) {
    let url = `${this.baseUrl}`

    if (filter) {
      url += `?${this.buildFilterUrl(filter)}`
    }
    return Http.get(url)
  }

  buildFilterUrl(filter) {
    return Object.keys(filter)
      .map((key) => {
        if (key === 'orderBy') {
          return filter.orderBy.map(
            (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
          )
        }
        if(filter[key] === null || filter[key] === '') {
          return ''
        }
        return `${key}=${filter[key]}`
      })
      .join('&')
  }
}

export default new UsersService()
